import { rpcDefinition } from "@redotech/merchant-sdk/rpc/definition";
import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcContractClient } from "@redotech/rpc/client";
import type { RedoMerchantRpcContract } from "./rpc-contract.generated";

export function createRedoMerchantRpcClient(
  options: ClientOptions<RedoMerchantRpcContract>,
): RedoMerchantRpcContract {
  return createRpcContractClient<RedoMerchantRpcContract>(
    rpcDefinition,
    options,
  );
}

export type RedoMerchantRpcClient = RedoMerchantRpcContract;
